<template>
  <div class="agg_collection mt-3">
    <div
      v-for="(index, key) in agg_format"
      :key="index"
      class="border-bottom pb-4 mb-4"
    >
      <div v-if="aggregators[index]">
        <h4 class="f17 font-weight-semi-bold text-uppercase mb-3">
          {{ aggs_translate[index] }}
        </h4>

        <div
          v-for="(agg_item, key_item) in aggregators[index]['buckets']"
          v-bind:key="agg_item.key"
          :class="key_item > 3 && !agg_show[index] ? 'hide' : ''"
          class="form-group d-flex align-items-center justify-content-between f13 text-lh-md text-secondary mb-1"
        >
          <div
            v-if="agg_item.key != '' && agg_item.key != ' ' && agg_item.key != null  "
            class="custom-control custom-checkbox"
          >
            <input
              type="checkbox"
              @click="searchCandidates(index,agg_item.key)"
              :value="agg_item.key"
              class="custom-control-input checkfilter"
              :id="
                    (index + '_' + agg_item.key)
                      .split(' ')
                      .join('_')
                      .replace('(', '')
                      .replace(')', '')
                  "
            />

            <label
              class="custom-control-label first-letter"
              :for="
                    (index + '_' + agg_item.key)
                      .split(' ')
                      .join('_')
                      .replace('(', '')
                      .replace(')', '')
                  "
            >{{ agg_item.key }}</label>
          </div>
          <small v-if="agg_item.key != '' && agg_item.key != ' ' && agg_item.key != null">{{ agg_item.doc_count }}</small>
        </div>
        <a
          v-if="
            aggregators[index]['buckets'].length
          > 3"
          class="link link-collapse small font-size-1"
          data-toggle="collapse"
          :href="'#collapse' + index"
          role="button"
          aria-expanded="false"
          :aria-controls="'collapse' + index"
        >
          <span
            @click="change(index)"
            class="link-collapse__default"
          >{{ agg_show[index] ? "Ver menos" : "Ver mais" }}</span>
          <span class="link__icon ml-1">
            <span class="link__icon-inner">
              {{ agg_show[index] ? "-" : "+" }}
            </span>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { gettersMap, mutationsMap } from "store/table.js";
export default {
  props: ["aggregators", "aggs_translate", "agg_format"],
  data: () => ({
    agg_show: {},
  }),
  mounted() {
    this.populationAggShow();
    mutationsMap.setWhere({});
  },
  methods: {
    populationAggShow() {
      for (let i in this.agg_format) {
        this.$set(this.agg_show, this.agg_format[i], false);
      }
    },
    change(index) {
      this.agg_show[index] = !this.agg_show[index];
    },
    searchCandidates(field, value) {
      let where = gettersMap.getWhere();
      if (Object.keys(where).length == 0 || where[field] == undefined) {
        where[field] = { all: [] };
      }

      if (where[field]["all"].includes(value)) {
        where[field]["all"].splice(where[field]["all"].indexOf("value"), 1);
        if (where[field]["all"].length == 0) delete where[field];
      } else {
        where[field]["all"].push(value);
      }

      mutationsMap.setWhere(where);
      mutationsMap.setSearchFlag();
    },
  },
  watch: {
    agg_format() {
      this.populationAggShow();
    },
  },
};
</script>
